export const Footer = ({ lastUpdated }) => {
  const formatUpdatedTime = () => {
    if (!lastUpdated) return null;
    const date = new Date(lastUpdated);
    return `Updated ${date.toLocaleString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      hour: '2-digit', 
      minute: '2-digit',
      timeZoneName: 'short'
    })}`;
  };

  return (
    <footer 
      className="bg-white border-t border-scoop-border py-7 px-5 md:px-10"
      data-testid="footer"
    >
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        {/* Brand */}
        <div className="font-display font-black text-lg text-scoop-ink">
          The <em className="italic text-scoop-blue">Scoop</em>
        </div>
        
        {/* Meta */}
        <p className="text-[0.7rem] text-scoop-muted leading-relaxed text-center">
          Safe, real, and age-smart news for curious kids ages 6–9<br />
          {/* Not "Human-reviewed": stories publish automatically once the three
              safety layers pass — there is no human approval step. Every claim
              here has to be one we can actually stand behind. */}
          AI-written · Safety-checked · Ad-free · © {new Date().getFullYear()}
        </p>
        
        {/* Right Side */}
        <div className="text-right">
          {formatUpdatedTime() && (
            <div className="text-[0.7rem] text-scoop-sage font-bold">
              {formatUpdatedTime()}
            </div>
          )}
          <div className="text-[0.7rem] text-scoop-muted mt-1">
            <a href="/privacy" className="hover:text-scoop-blue transition-colors">Privacy</a>
            {" · "}
            <a href="/guidelines" className="hover:text-scoop-blue transition-colors">For Parents</a>
            {" · "}
            <a href="/guidelines" className="hover:text-scoop-blue transition-colors">Guidelines</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
